import PhoneCard from './PhoneCard';

export default PhoneCard;
